const initials = "answerList/";
export const UPDATE_SINGLE_ANSWER_INFO = `${initials}UPDATE_SINGLE_ANSWER_INFO`;
export const UPDATE_ANSWER_LIST = `${initials}UPDATE_ANSWER_LIST`;
export const UPDATE_FILTER = `${initials}UPDATE_FILTER`;
export const UPDATE_REDUCER = `${initials}UPDATE_REDUCER`;